import styled, { css } from "styled-components";
import type { MapProps } from "./Map.types";

export const MapContainer = styled.div<MapProps>`
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;

  .mapboxgl-canvas:focus {
    outline: none !important;
  }

  /* .mapboxgl-marker-anchor-center {
    display: none;
  } */
  /* .mapboxgl-ctrl-geocoder--input {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0 0.6rem 0 1.9rem;
    font-size: ${({ theme }) => theme.fontSizes[2]}rem;
    min-height: 50px;
    color: rgb(51, 51, 51) !important;
    background-color: ${({ theme }) => theme.colors.white.white100tra};
    border-radius: ${({ theme }) => theme.radii[1]}px;
    -webkit-border-radius: ${({ theme }) => theme.radii[1]}px;
    -moz-border-radius: ${({ theme }) => theme.radii[1]}px;
    border: 0;
    ${({ focus }) =>
      focus &&
      css`
      outline: 3px solid ${({ theme }) => theme.colors.primary.primary120} !important;
      outline-offset: -3px;
    `}

    input {
      max-height: 50px !important;
    }
  } */
  /* .mapboxgl-ctrl-geocoder--icon-search {
    position: absolute;
    top: 17px;
    left: 10px;
    transform: scale(1.2);
    z-index: 1;
  }
  .mapboxgl-ctrl-geocoder--button {
    position: absolute;
    top: 10px;
    right: 10px;

    height: 30px !important;
    width: 30px !important;
    padding: 0 !important;
    border: 0 !important;

    border-radius: ${({ theme }) => theme.radii[0]}px;
    background-color: ${({ theme }) => theme.colors.greyscale.greyscale20tra};
    &:hover {
      background-color: ${({ theme }) => theme.colors.greyscale.greyscale40tra};
    }
  } */
  /* .mapboxgl-ctrl-geocoder--icon-close {
    height: 16px !important;
    width: 16px !important;
  } */

  .mapboxgl-popup {
    pointer-events: none !important;
    user-select: none !important;
  }
  .mapboxgl-popup-content {
    font-family: nunito;
    font-size: 14px;
    font-weight: 700;
    padding: 8px;
    pointer-events: none !important;
    user-select: none !important;
    border-radius: 8px;
    border: 0px solid white !important;
    /* ${({ theme }) =>
      theme.layer({
        interactive: false,
        type: "white",
        lightness: "dark",
        border: "light",
        shadow: false,
      })} */
  }

  /* .mapboxgl-popup-tip {
    width: 0;
    height: 0;
    border: 10px solid transparent;
    z-index: 1;
  }
  .mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {
    align-self: center;
    border-bottom: none;
    border-top-color: #fff;
  } */

  /* .mapboxgl-ctrl-geolocate {
    width: 50px;
    height: 50px;
    border-radius: 8px !important;

    ${({ theme }) =>
      theme.layer({
        interactive: false,
        type: "white",
        lightness: "dark",
        border: "dark",
        shadow: false,
      })}
  } */
  /* 
  .marker {
  background-image: url("https://media.giphy.com/media/Bfa45K0r6cCIw/giphy.gif");
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
} */

  .mapboxgl-ctrl-fullscreen {
    position: absolute;
    display: block;
    right: 0px;
    top: 10px;
    width: 33px;
    z-index: 1;
    border-radius: ${({ theme }) => theme.radii[1]}px;

    /* ${({ theme }) =>
      theme.layer({
        interactive: false,
        type: "white",
        lightness: "dark",
        border: "dark",
        shadow: false,
      })} */
  }
  .mapboxgl-ctrl-geolocate {
    display: none;
  }

  .mapboxgl-ctrl-attrib.mapboxgl-compact {
    min-height: 24px;
    min-width: 24px;
    background-color: transparent;
    margin: 0px;
    padding: 0px;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    gap: 4px;
    margin-block: -2px;
  }
  .mapboxgl-ctrl-attrib.mapboxgl-compact-show .mapboxgl-ctrl-attrib-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    column-gap: 4px;
  }
  .mapboxgl-ctrl-attrib.mapboxgl-compact-show .mapboxgl-ctrl-attrib-inner a {
    white-space: nowrap;
  }
  .mapboxgl-ctrl-attrib-button {
    position: relative;
    flex-shrink: 0;
  }
  .mapboxgl-ctrl-attrib-button:focus {
    box-shadow: 0 0 0 0 transparent;
  }
  .mapboxgl-ctrl-attrib-button:focus-visible {
    box-shadow: 0 0 0 2px var(--focused-default);
  }

  .mapboxgl-ctrl-top-right {
    display: none;
  }

  .mapboxgl-ctrl-bottom-left {
    z-index: 0;

    @media (max-width: 768px) {
      position: fixed !important;
      top: ${({ id }) =>
        id === "map-normal" ? "calc(100svh - 225px)" : "calc(100svh - 120px)"};
    }
  }

  .mapboxgl-ctrl-bottom-right {
    z-index: 0;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 12px;
    margin: 12px;

    @media (max-width: 768px) {
      position: fixed !important;
      top: ${({ id }) =>
        id === "map-normal" ? "calc(100svh - 235px)" : "calc(100svh - 130px)"};
    }
  }

  .mapboxgl-ctrl-group {
    display: none;
    overflow: hidden;
    @media (min-width: 768px) {
      display: block;
      margin: 0px;
      z-index: 1;
      width: 36px;
      flex-shrink: 0;

      border-radius: 20px !important;
      background-color: white !important;
      border: 0px solid white !important;
      box-shadow: 0px 12px 8px -1px rgba(134, 124, 90, 0.2) !important;
      padding-bottom: 5px;

      /* ${({ theme }) =>
        theme.layer({
          interactive: false,
          type: "white",
          lightness: "dark",
          border: "dark",
          shadow: false,
        })} */
    }
  }

  .mapboxgl-ctrl-zoom-in:before {
    content: "";
    position: absolute;
    left: 6px;
    top: 28px;
    height: 2px;
    font-weight: 100;
    width: 20px; /* or 100px */
    /* border-bottom: 2px solid
      ${({ theme }) => theme.colors.greyscale.greyscale20tra}; */
  }

  .mapboxgl-ctrl-zoom-out:before {
    content: "";
    position: absolute;
    left: 6px;
    top: 55px;
    height: 2px;
    width: 20px; /* or 100px */
    /* border-bottom: 2px solid
      ${({ theme }) => theme.colors.greyscale.greyscale20tra}; */
  }

  .mapboxgl-ctrl-zoom-in {
    margin-top: 4px !important;
  }
  .mapboxgl-ctrl-zoom-in,
  .mapboxgl-ctrl-zoom-out,
  .mapboxgl-ctrl-compass {
    background-color: transparent;
    border: 0;
    width: 28px;
    margin-left: 4px;
    margin-right: 4px;
    transform: scale(0.8);
    border-radius: ${({ theme }) => theme.radii[4]}px !important;
  }

  /* .mapboxgl-ctrl-zoom-out {
    border-radius: 0px;
  } */

  .mapboxgl-ctrl {
    /* display: none; */
    /* position: absolute;
    margin-bottom: 16svh; */

    @media (min-width: 768px) {
      display: block;
    }
  }
  /* .mapboxgl-ctrl-logo {
    display: none;
  } */
`;
